(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.news = {
    attach: function(context, settings) {
      jQuery('.block-views-exposed-filter-blocknews-news-page').once('filter-toggle').each(function() {
        // Add toggle button
        const $block = jQuery(this);
        const $form = $block.find('form');
        const $btn = jQuery('<button class="search-filter-show-hide">Search & Filter</button>');
        // search submit
        const $searchSubmit = jQuery('<button type="submit" value="Search" class="button js-form-submit form-submit form-search btn">Search</button>');
        const $searchField = $form.find('.js-form-item-keyword');

        $btn.click(function() {
          $block.toggleClass('open');
          $btn.toggleClass('open');
        });
        $form.before($btn);
        $searchField.after($searchSubmit);
        $searchSubmit.after(jQuery('<div class="form-clearfix"></div>'));
      });
    }
  };

})(jQuery, Drupal);
